import React, { FC } from 'react';
import { createPortal } from 'react-dom';
import SystemMessagesComponent from './SystemMessagesComponent';

const SystemMessagesWrapperComponent: FC = () => {
  const container = document.querySelector('.app-systemmessages-container');
  if (container) {
    return (
      <>
        {createPortal(
          <SystemMessagesComponent />,
          container,
        )}
      </>
    );
  }
  return null;
};

SystemMessagesWrapperComponent.displayName = 'SystemMessagesWrapperComponent';
export default SystemMessagesWrapperComponent;
